import dayjs from 'dayjs';
import { getMMDDYY } from './date';
import { AllTarget, FormattedAllTarget, TargetListItem, TargetListStatus } from '../../types';

export const formatAllTargetItem = (item: AllTarget): FormattedAllTarget => ({
  targetId: item.tsg_rand,
  title: item.tsg_name,
  createdAt: item.tsg_date,
});

export const formatTargetCreatedDate = (timestamp?: number) => {
  if (!timestamp) return 'N/A';
  return getMMDDYY(timestamp, 'D MMM, YYYY');
};

// Tolerant date formatter for the target list: core may send unix seconds, unix millis or an ISO string.
export const formatTargetDate = (value?: number | string | null, format = 'D MMM YYYY') => {
  if (value === null || value === undefined || value === '' || value === 0 || value === '0') return '-';

  const numeric = typeof value === 'number' ? value : /^\d+$/.test(String(value)) ? Number(value) : NaN;
  const parsed = Number.isNaN(numeric) ? dayjs(String(value)) : numeric < 1e11 ? dayjs.unix(numeric) : dayjs(numeric);

  return parsed.isValid() ? parsed.format(format) : '-';
};

// Legacy pending/completed rows ({ targetId, title, image, keyPoints[] }) -> list row shape.
// keyPoints are pre-formatted display strings, so balance is passed through as-is.
export const formatLegacyTargetRow = (item: any, status: Exclude<TargetListStatus, 'all'>): TargetListItem => ({
  targetId: item?.targetId,
  title: item?.title ?? '',
  status,
  userBalance: item?.keyPoints?.[1]?.value ?? null,
});

// Legacy all-targets rows (raw tsg_* columns) -> list row shape.
export const formatLegacyAllTargetRow = (item: AllTarget): TargetListItem => ({
  targetId: item.tsg_rand,
  title: item.tsg_name,
  status: item.tsg_status === 0 ? 'active' : item.tsg_status === 1 ? 'completed' : 'unknown',
  createdAt: item.tsg_date,
});
